import { useLayoutEffect } from 'react'
import { getVarValue } from '../utils/Sparky'

const TW_DARK_CLS = 'tw-dark'

const useLightModeOverride = (enable: boolean) => {
  useLayoutEffect(() => {
    const { classList } = document.documentElement
    const config = enable && getVarValue('light_mode_override')
    const hasDarkCls = classList.contains(TW_DARK_CLS)
    const observer = window.MutationObserver && new MutationObserver(() => {
      if (config && classList.contains(TW_DARK_CLS)) {
        classList.remove(TW_DARK_CLS)
      }
    })
    if (config && hasDarkCls) {
      classList.remove(TW_DARK_CLS)
      observer?.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
        childList: false,
        characterData: false
      })
    }
    return () => {
      if (config && hasDarkCls) {
        classList.add(TW_DARK_CLS)
        observer?.disconnect()
      }
    }
  }, [enable])
}
export default useLightModeOverride
